<script>
export default {
  name: 'BitrixPriceForm',
  //   props: {
  //     containerId: {
  //       type: String,
  //       required: true,
  //     },
  //   },
  render: function(createElement) {
    const priceScript = createElement(
      'script',
      {
        attrs: {
          // id: 'bx24_form_inline',
          'data-b24-form': 'inline/19/36h3oj',
          'data-skip-moving': true,
        },
      },
      `(function(w,d,u){
                var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
                var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
        })(window,document,'https://cdn.bitrix24.ru/b937185/crm/form/loader_19.js');`
    )

    // const wrapper = createElement(
    //   'div',
    //   {
    //     attrs: {
    //       id: 'bitrix-price-form',
    //     },
    //   },
    //   [priceScript]
    // )

    return priceScript
  },
}
</script>

<style scoped></style>
